import graphql__c9842116e707b2c323ab from "./__generated__/UsersMapDetails_usersMap.graphql.js";import { Suspense } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import MapUsersList from "../UsersMap/MapUsersList";
import { BoxSpinner } from "../../Utils/Spinner";
import MapFilters from "../MapFilters";
import { useFormatMessage } from "../../Intl/Context";

const UsersMapDetails = props => {
  const usersMap = useFragment(UsersMapDetails_usersMap, props.usersMap);

  const t = useFormatMessage();
  const filtersTitle = t(intlMessages.filtersTitle);

  return (
    <>
      <div className="map-sidebar-element map-sidebar-element-users-map boxes-list">
        <MapFilters map={usersMap} title={filtersTitle} />

        <Suspense fallback={<BoxSpinner />}>
          <MapUsersList usersMap={usersMap} />
        </Suspense>
      </div>
    </>
  );
};

const UsersMapDetails_usersMap = graphql__c9842116e707b2c323ab;

export default UsersMapDetails;

const intlMessages = defineMessages({
  filtersTitle: {
    id: "map.usersMapDetails.filtersTitle",
    defaultMessage: "Filtrer les utilisateurs"
  }
});
